import clsx from 'clsx';

export type StepperHeaderProps = {
  title: string;
  subtitle?: string;
  currentStepIndex: number;
  stepsCount?: number;
};

export const StepperHeader = ({ title, subtitle = '', currentStepIndex, stepsCount = 0 }: StepperHeaderProps) => (
  <div className="relative flex h-18 items-center justify-between border-b border-border-primary px-8">
    <h1 className="text-t24-sb">{title}</h1>
    <h2 className="text-t20-sb text-text-secondary">{subtitle}</h2>

    {!!stepsCount && (
      <div className="absolute right-0 bottom-0 flex justify-end gap-3">
        {Array.from({ length: stepsCount }).map((_, stepIndex) => {
          const isCompleted = stepIndex <= (currentStepIndex || 0);
          return (
            <div
              className={clsx('h-1 w-12', isCompleted ? 'bg-surface-brand' : 'bg-surface-state-neutral-light')}
              key={stepIndex}
            />
          );
        })}
      </div>
    )}
  </div>
);
